export const LOGIN = "LOGIN";
export const GET_ACTIVE_BILL = "GET_ACTIVE_BILL";
export const GET_ONE_BILL = "GET_ONE_BILL";
export const ADD_BILL = "ADD_BILL";
export const GET_ALL_BRANCHES = "GET_ALL_BRANCHES";
export const GET_PRODUCT_FIELDS = "GET_PRODUCT_FIELDS";
export const GET_PRODUCT_LIST = "GET_PRODUCT_LIST";
export const GET_PRODUCT_ID = "GET_PRODUCT_ID";
export const GET_PRODUCT_BY_ID = "GET_PRODUCT_BY_ID";
export const ADD_PAYMENT_TO_BILL = "ADD_PAYMENT_TO_BILL";
export const REMOVE_PAYMENT = "REMOVE_PAYMENT";
export const CHANGE_BILL_TO_DONE = "CHANGE_BILL_TO_DONE";
export const REMOVE_BILL = "REMOVE_BILL";
export const GET_BILL = "GET_BILL";
export const GET_DAILY_REPORT = "GET_DAILY_REPORT";
export const UPDATE_Bill = "UPDATE_Bill";
export const GET_INTERVAL_REPORTS = "GET_INTERVAL_REPORTS";
export const GET_INTERVAL_BILL_REPORT = "GET_INTERVAL_BILL_REPORT";
export const GET_CHARTS_REPORT = "GET_CHARTS_REPORT";
export const FETCH_DATE = "FETCH_DATE";
export const GET_DATE_RANGE = "GET_DATE_RANGE";
export const GET_USERS_CUSTOMERS = "GET_USERS_CUSTOMERS";
export const GET_ALL_BILLS = "GET_ALL_BILLS";
export const GET_A_CUSTOMER = "GET_A_CUSTOMER";
export const GET_ALL_CHEQUES = "GET_ALL_CHEQUES";
export const GET_REMAINED_BILLS = "GET_REMAINED_BILLS";
export const GET_REMAINED_CHEQUES = "GET_REMAINED_CHEQUES";
export const GET_SUPPLIERS = "GET_SUPPLIERS";
export const GET_THE_SUPPLIER = "GET_THE_SUPPLIER";
export const GET_CLASS_TYPES_AND_CITY = "GET_CLASS_TYPES_AND_CITY";
export const ADD_CUSTOMER = "ADD_CUSTOMER";
export const REMOVE_ITEM = "REMOVE_ITEM";
export const ADD_SUPPLIER = "ADD_SUPPLIER";
export const UPDATE_BILL_ITEM = "UPDATE_BILL_ITEM";
export const GET_SUPPLIER_FACTORS = "GET_SUPPLIER_FACTORS";
export const GET_SUPPLIER_FACTOR = "GET_SUPPLIER_FACTOR";
export const DELETE_SUPPLIER_FACTOR = "DELETE_SUPPLIER_FACTOR";
export const ADD_SUPPLIER_FACTOR = "ADD_SUPPLIER_FACTOR";
export const ADD_FACTOR_ITEM = "ADD_FACTOR_ITEM";
export const ADD_PAYMENT_TO_SUPPLIER_BILL = "ADD_PAYMENT_TO_SUPPLIER_BILL";

// kari nadashte bashim
export const FETCH = types => `FETCH_${types}`;
export const SUCSS = types => `SUCSS_${types}`;
export const FAILD = types => `FAILD_${types}`;
